// the following import is used to ensure the block suite editor effects are run
import '../blocksuite/block-suite-editor';

import { DebugLogger } from '@affine/debug';
import { DEFAULT_WORKSPACE_NAME } from '@affine/env/constant';
import onboardingUrl from '@affine/templates/onboarding.zip';
import onboardingZhUrl from '@affine/templates/onboarding-zh.zip';
import { ZipTransformer } from '@blocksuite/affine/widgets/linked-doc';

import { DocsService } from '../modules/doc';
import { OrganizeService } from '../modules/organize';
import {
  getAFFiNEWorkspaceSchema,
  type WorkspacesService,
} from '../modules/workspace';
import {
  detectSystemLanguage,
  getOnboardingTemplateName,
} from './language-detector';
import { getEnv } from '../modules/cloud/constant';

/**
 * 从CDN获取onboarding模板的URL
 * 如果配置了CDN地址，则从CDN加载；否则使用本地打包的版本
 */
async function getLocalOnboardingUrl(): Promise<string> {
  const language = detectSystemLanguage();
  // 使用本地版本，根据语言选择对应的模板
  if (language.startsWith('zh')) {
    return onboardingZhUrl;
  }

  return onboardingUrl;
}

export async function buildShowcaseWorkspace(
  workspacesService: WorkspacesService,
  flavour: string,
  workspaceName: string
) {
  const meta = await workspacesService.create(flavour, async docCollection => {
    docCollection.meta.initialize();
    docCollection.doc.getMap('meta').set('name', workspaceName);
    const language = detectSystemLanguage();
    const env = getEnv();
    const templateName = getOnboardingTemplateName(language);
    const cdnOnboardingUrl = `https://wy-static.wenxiaobai.com/wenxiaobai-web/muset/${env}/${templateName}`;
    // 从CDN或本地获取模板URL
    const localOnboardingUrl = await getLocalOnboardingUrl();

    // 添加错误处理和重试机制
    let blob: Blob;
    try {
      const response = await fetch(cdnOnboardingUrl);
      console.log('aaaaaaaaaaacdnOnboardingUrl', cdnOnboardingUrl);
      if (!response.ok) {
        throw new Error(
          `Failed to fetch template: ${response.status} ${response.statusText}`
        );
      }
      blob = await response.blob();
    } catch (error) {
      console.error(
        'Failed to load onboarding template from CDN, falling back to local:',
        error
      );
      // 如果CDN失败，回退到本地英文版本
      const fallbackResponse = await fetch(localOnboardingUrl);
      blob = await fallbackResponse.blob();
    }
    console.log('aaaaaaaaaaablob', blob);
    await ZipTransformer.importDocs(
      docCollection,
      getAFFiNEWorkspaceSchema(),
      blob
    );
  });

  const { workspace, dispose } = workspacesService.open({ metadata: meta });

  await workspace.engine.doc.waitForDocReady(workspace.id);

  const docsService = workspace.scope.get(DocsService);

  // should jump to "Getting Started"
  const defaultDoc = docsService.list.docs$.value.find(
    p =>
      p.title$.value.startsWith('Getting Started') ||
      p.title$.value.startsWith('从这里开始')
  );
  // const folderTutorialDoc = docsService.list.docs$.value.find(p =>
  //   p.title$.value.startsWith('How to use folder and Tags')
  // );

  // create default organize
  if (defaultDoc) {
    const organizeService = workspace.scope.get(OrganizeService);
    // const folderId = organizeService.folderTree.rootFolder.createFolder(
    //   'First Folder',
    //   organizeService.folderTree.rootFolder.indexAt('after')
    // );

    organizeService.folderTree.rootFolder.createLink(
      'doc',
      defaultDoc.id,
      organizeService.folderTree.rootFolder.indexAt('after')
    );

    // const firstFolderNode =
    //   organizeService.folderTree.folderNode$(folderId).value;
    // firstFolderNode?.createLink(
    //   'doc',
    //   folderTutorialDoc.id,
    //   firstFolderNode.indexAt('after')
    // );
  }

  dispose();

  return { meta, defaultDocId: defaultDoc?.id };
}
export async function deleteShowcaseWorkspace(
  workspacesService: WorkspacesService,
  id: string,
  flavour: string
) {
  await workspacesService.deleteWorkspace({ id, flavour });
}

const logger = new DebugLogger('createFirstAppData');

export async function createFirstAppData(workspacesService: WorkspacesService) {
  if (localStorage.getItem('is-first-open') !== null) {
    return;
  }
  localStorage.setItem('is-first-open', 'false');
  //  TODO 如何确保创建一个cloude文档
  const { meta, defaultDocId } = await buildShowcaseWorkspace(
    workspacesService,
    'local',
    DEFAULT_WORKSPACE_NAME
  );
  logger.info('create first workspace', defaultDocId);
  return { meta, defaultPageId: defaultDocId };
}
